import { AlertTriangle } from '@untitled-ui/icons-react';

import { Button } from '../../../../../../components/buttons/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '../../../../../../components/dialog';
import { FeaturedIcon } from '../../../../../../components/featured-icon';
import { getConfig } from '../../../../../../config';
import { tNamespace } from '../../../../../../services/translation';
import { convertPlanStrToKind } from '../../../../../../shared/subscription';

const t = tNamespace('components.downgrade-impossible-modal');

type DowngradeImpossibleModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentUserCount: number;
  planUserLimit: number;
  planName?: string;
  onManageMembers?: () => void;
};

export function DowngradeImpossibleModal(props: DowngradeImpossibleModalProps) {
  const {
    open,
    onOpenChange,
    currentUserCount,
    planUserLimit,
    planName = 'GROW',
    onManageMembers,
  } = props;

  // figure the translation for the users limitation
  const planKind = convertPlanStrToKind(planName);
  let usersLimitTranslation =
    planUserLimit === 1
      ? t('userLimit', { count: planUserLimit })
      : t('usersLimit', { count: planUserLimit });
  if (getConfig().plans[planKind]?.areUsersUnlimited) {
    usersLimitTranslation = t('usersUnlimited');
  }

  function handleManageMembers() {
    if (onManageMembers != null) {
      onManageMembers();
    } else {
      onOpenChange(false);
    }
  }

  function handleCancel() {
    onOpenChange(false);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent hasCloseButton className="max-w-full">
        <div className="flex flex-col gap-6">
          {/* Warning Icon */}
          <div className="flex justify-center">
            <FeaturedIcon icon={<AlertTriangle />} size="md" color="yellow" border={true} />
          </div>

          {/* Title and Description */}
          <div className="flex flex-col gap-2">
            <DialogTitle align="center">{t('title')}</DialogTitle>
            <DialogDescription align="center">{t('description', { planName })}</DialogDescription>
          </div>

          {/* Divider */}
          <div className="h-px w-full bg-branding-gray-200" />

          {/* Members Info Section */}
          <div className="flex flex-col gap-4">
            <div className="flex items-start justify-between">
              <div className="flex flex-col gap-1">
                <p className="font-body-2-sb text-gray">{t('membersLabel')}</p>
                <p className="font-body-2-sb text-dark-gray">
                  {t('currentUsers', { count: currentUserCount })}
                </p>
              </div>
              <div className="flex flex-col items-end gap-1">
                <p className="font-body-2-sb text-gray">{t('planLimitsLabel', { planName })}</p>
                <p className="font-body-2-sb w-fit rounded-lg bg-red-50 px-2 py-1 text-red-600">
                  {usersLimitTranslation}
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <DialogFooter className="mt-2" isColumn>
            <Button size="xl" variant="accent" className="flex-1" onClick={handleManageMembers}>
              {t('manageMembers')}
            </Button>
            <Button size="xl" variant="outline" className="flex-1" onClick={handleCancel}>
              {t('cancel')}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
